import * as THREE from 'three'

export function getVertexCount(geometry: THREE.BufferGeometry): number {
  return geometry.getAttribute('position').count
}

export function getFaceCount(geometry: THREE.BufferGeometry): number {
  return getVertexCount(geometry) / 3
}
